import { DEFAULT_PROJECT_VIEW_MODE, IMAGE_MODE, PROJECT_VIEW_MODE } from '@utils/constants';

// Builds a mode-aware project URL. `mode` is explicit here because, unlike
// internal navigation inside an established ProjectModeProvider, callers at
// this level (project list, cards) have no ambient route mode to derive from.
export const buildProjectUrl = (uuid, mode = DEFAULT_PROJECT_VIEW_MODE, suffix = '') => {
	const base = mode === PROJECT_VIEW_MODE.MODEL ? '/projects' : '/projects/v2';
	return `${base}/${uuid}${suffix ? `/${suffix}` : ''}`;
};

// A project's page from a list, card or link: video projects have their own page (no view modes), every other
// project the given view mode.
export const projectHomeUrl = (uuid, imageMode, mode = DEFAULT_PROJECT_VIEW_MODE, suffix = '') =>
	imageMode === IMAGE_MODE.VIDEO
		? `/video-projects/${uuid}${suffix ? `/${suffix}` : ''}`
		: buildProjectUrl(uuid, mode, suffix);

// Search params that only mean something in one view mode: `model` is the
// ModelPicker selection, `collection_uuid` the CollectionPicker selection.
export const MODE_SPECIFIC_SEARCH_PARAMS = Object.freeze(['model', 'collection_uuid']);

// Drops the mode-specific params from a query string (with or without the
// leading `?`) so a project URL can be re-based onto the other view mode
// without carrying a selection that mode can't resolve. Returns `''` or a
// `?`-prefixed string, ready to append to buildProjectUrl().
export const stripModeSearchParams = search => {
	const params = new URLSearchParams(search);
	MODE_SPECIFIC_SEARCH_PARAMS.forEach(param => params.delete(param));
	const rest = params.toString();
	return rest ? `?${rest}` : '';
};
